import React, { Component } from 'react';
import { Modal, Select, Radio, Input, InputNumber, Button, message, Spin, DatePicker, Tooltip } from 'antd';
import SelectinvestigationJdeCode from './SelectinvestigationJdeCode';
import SearchRetrieve from '../../../common/SearchRetrieve.new.js';
import { getMatchOption } from '../../../shared/selectFn';
import deepClone from '../../../shared/deepClone';
import ExportUtil from '../../../../common/ExportUtil';
import UploadFile from '../../../common/UploadFile';
import Fetch from '../../../../common/Fetch';
import EditableTable from './EditableTable';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';
import Text from '../../../basicElement/Text';
import moment from 'moment';
import { getEmployeeCode } from '../../../common/getEmployeeCode';
import './style.less';

const { Option } = Select; 
const RadioGroup = Radio.Group;

const CONSTANTS = {
    add: {
        add: true,
        editable_pro: true,        // 项目
        editable_con: true,        // 合同
        editable_req: true,        // 请款
        TITLE: '添加请款',
        SAVE_URL: API_URL.contract.addContractRemittanceApplication,
    },
    autoAdd: {
        autoAdd: true,
        editable_pro: true,        // 项目
        editable_con: true,        // 合同
        editable_req: true,        // 请款
        TITLE: '添加请款',
        SAVE_URL: API_URL.contract.addContractRemittanceApplication,
    },
    edit: {
        edit: true,
        editable_con: true,        // 合同
        editable_req: true,        // 请款
        TITLE: '修改请款',
        SAVE_TYPE: 'MODIFY',
        SAVE_URL: API_URL.contract.editContractRemittanceApplication,
    },
    initiate: {
        initiate: true,
        TITLE: '发起请款',
        SAVE_URL: API_URL.contract.startContractRemittanceApplication,
    },
    update: {
        update: true,
        editable_req: true,        // 请款
        TITLE: '更新请款进度',
        SAVE_TYPE: 'UPDATE_PROGRESS',
        SAVE_URL: API_URL.contract.editContractRemittanceApplication,
    },
    copy: {
        copy: true,
        editable_pro: true,        // 项目
        editable_con: true,        // 合同
        editable_req: true,        // 请款
        TITLE: '复制新建',
        SAVE_URL: API_URL.contract.addContractRemittanceApplication,
    },
    RATE_TO_AMOUNT: true,
    CNY: true,
};
const defaultList = [
    { label: '是', value: '1' },
    { label: '否', value: '0' }
];
const cashReqNodeTypeOptions = [
    { label: '按例数', value: 'NNF' },
    { label: '按周期', value: 'CYCLE' },
];
const calculateTypeOptions = [
   { label: '由比例计算金额', value: 'RATE_TO_AMOUNT' },
   { label: '由金额计算比例', value: 'AMOUNT_TO_RATE' },
];
const requestColumns = [{
    title: '请款联系人姓名',
    key: 'userName',
    width: 160,
}, {
    title: '请款联系人电话',
    key: 'userMobile',
    width: 160,
}, {
    title: '请款联系人邮箱',
    key: 'userMail',
}];
const invoiceColumns = [{
    title: '发票邮寄联系人姓名',
    key: 'userName',
    width: 125,
}, {
    title: '发票邮寄联系人电话',
    key: 'userMobile',
    width: 125,
}, {
    title: '发票邮寄联系人邮箱',
    key: 'userMail',
    width: 140,
}, {
    title: '发票邮寄地址',
    key: 'address',
}];
const initialTableData = list => (list || []).map(i => ({ ...i, editable: true}));
const uploadType = 'CONTRACT_REQUEST_FUNDS';

class Update extends Component {
    highlight = false

    state = {
        type: 'add',
        canEdit: false,
        visible: false,
        loading: false,
        list: [],
        record: {},
        uesrData:{},
        saveParams: {},
        fileList: [],
        requestData: [],
        invoiceData: [],
        nodeList: [],
        remittanceNumList: [],
        relationContractList: [],
        paymentAmountList: [],
        paymentStopBreathingIdList: [],
        JdeContractSiteList: [],
        investigationOption: {},
    }

    dictLoaded = false

    // 当前用户信息与项目数据无关，首开一次；请求失败则下次打开自动重试
    loadUserInfo = () => {
        if (this.dictLoaded) {
            return;
        }
        sessionStorage.curEmployeeCode && getEmployeeCode().then(res => {
            this.dictLoaded = true;
            this.setState({ uesrData: res.data.user });
        });
    }

    queryInvestigation = () => {
        const { type, saveParams } = this.state;
        const { investigationId, investigationName } = saveParams;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.selectInvestigationForAddRemittance, {
            investigationId,
            investigationName,
            type: (CONSTANTS[type]['initiate'] || CONSTANTS[type]['edit'] || CONSTANTS[type]['update']) ? 'startRemittance' : null,
            needRoleBA: (CONSTANTS[type]['add'] || CONSTANTS[type]['autoAdd'] || CONSTANTS[type]['copy']) ? 1 : 0,
        }).then(res => {
            const { data } = res;
            const [investigationOption] = data || [];
            this.setState({
                loading: false,
                investigationOption,
            }, () => {
                this.loadRelationContractList(investigationId, CONSTANTS[type]['autoAdd']);
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    acceptState = (state) => {
        this.timestamp = Date.now();
        state = deepClone(state);
        state.saveParams.remittanceNum = undefined;
        state.saveParams.isAdvanceCollection = undefined;
        this.highlight = true;
        this.loadUserInfo();
        this.setState({
            ...state,
            fileList: [],
            visible: true,
        }, () => {
            this.queryRemittanceNum();
            this.loadRelationContractList(state.saveParams.investigationId);
        });
    }

    show = (record, type) => {
        this.timestamp = Date.now();
        this.loadUserInfo();
        const { cashReqUsers, invoiceMailUsers, pmUserList, bdUserList, baUserList, remittanceNum, remittanceNodeId, ...rest } = record || {};
        const { invId, invName, invState } = sessionStorage;

        if (CONSTANTS[type]['copy']) {
            rest.paymentProgressId = undefined;
            rest.paymentProgressComment = '';
            rest.isAdvanceCollection = undefined;
            //请款节点相关重置
            rest.cashReqNode = undefined;
            rest.remittanceNum = undefined;
            rest.calculateType = undefined;
            rest.cashReqNodeType = undefined;
            rest.cashReqNodeNum = undefined;
            rest.cashReqRate = undefined;
            rest.initialContractAmount = undefined;
            rest.remittanceAmount = undefined;
            rest.expenseTypeId = undefined;
            // delete rest.contractRemittanceApplicationId;
        } else {
            const newRemittanceNum = ((remittanceNum || '').match(/\d+/) || [])[0] || undefined;
            this.remittanceNum = newRemittanceNum;
            rest.remittanceNum = newRemittanceNum;
            rest.remittanceNodeId = remittanceNodeId,
            record && (record.remittanceNum = newRemittanceNum);
        }
        this.setState({
            type,
            fileList: [],
            visible: true,
            record: record || {},
            requestData: initialTableData(cashReqUsers),
            invoiceData: initialTableData(invoiceMailUsers),
            saveParams: {
                calculateType: calculateTypeOptions[0].value,
                investigationId: invId,
                investigationName: invName,
                ...rest,
                isVerification: record ? record.isVerification ? record.isVerification : '0' : '0',
                invSiteIds: record ? record.contractSiteIds ? record.contractSiteIds.split(';') : [] : [],
            },
        }, () => {
            if (CONSTANTS[type]['add']) {
                invState == 1 && this.queryInvestigation();
            } else {
                !CONSTANTS[type]['autoAdd'] && !CONSTANTS[type]['copy'] && this.queryFileList();
                this.queryInvestigation();
                this.queryJdeContractSiteList();
                this.queryRemittanceNum();
                this.queryStopBreathingCode();
                this.queryStopBreathingReason(this.state.saveParams.paymentStopBreathingCode);
                this.queryContractRemittanceNodes();
            }
        });
    }

    hide = () => {
        this.highlight = false;
        this.setState({
            canEdit: false,
            visible: false,
            fileList: [],
            nodeList:[],
            JdeContractSiteList: [],
            relationContractList: [],
            investigationOption: {},
        });
    }

    loadData = () => {
        const { invId } = sessionStorage;
        const { saveParams } = this.state;
        const { contractRemittanceApplicationId } = saveParams;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.queryContractRemittanceList, {
            offset: 1,
            contractRemittanceApplicationId,
            curInvId: invId,
        }).then(res => {
            const { datas } = res.data;
            const [record] = datas || [];
            const { cashReqUsers, invoiceMailUsers, remittanceNum } = record || {};
            
            if (remittanceNum) {
                const newRemittanceNum = ((remittanceNum || '').match(/\d+/) || [])[0];
                record.remittanceNum = newRemittanceNum;
                record.isAdvanceCollection = newRemittanceNum === '1' ? '1' : '0';
            }

            this.setState({
                loading: false,
                record: record || {},
                requestData: initialTableData(cashReqUsers),
                invoiceData: initialTableData(invoiceMailUsers),
            }, () => {
                this.props.loadData();
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    queryFileList = () => {
        const { saveParams } = this.state;
        const { contractRemittanceApplicationId } = saveParams;
        Fetch.post(API_URL.common.queryEnclosureFileList, {
            uploadType,
            relateId: contractRemittanceApplicationId
        }).then(res => {
            const fileList = res.datas || [];
            fileList.forEach(item => {
                item.response = { fileMetaId: item.fileMateId };
                item.uid = item.fileMateId;
            });
            this.setState({
                fileList,
                loading: false,
            });
        }).catch(error => {
            console.error(error);
        });
    }

    loadRelationContractList = (investigationId, shouldSelect) => {
        const setData = (data) => {
            this.setState({ relationContractList: data }, () => {
                if (shouldSelect) {
                    const { saveParams } = this.state;
                    const { investigationJdeContractId } = saveParams;
                    this.handleSelectChange(investigationJdeContractId, 'investigationJdeContractId');
                }
                this.recomputeContractAmount();
            });
        };
        if (investigationId) {
            const { type } = this.state;
            Fetch.post(API_URL.contract.selectContractForAddRemittance, {
                investigationId,
                type: 'application',
                isModify: CONSTANTS[type]['add'] || CONSTANTS[type]['autoAdd'] ? 0 : 1,
            }).then(res => {
                setData(res.data);
            }).catch(error => {
                console.error(error);
            });
        } else {
            setData([]);
        }
    }

    recomputeContractAmount = () => {
        const { type, canEdit, saveParams: { calculateType, cashReqRate, remittanceAmount, initialContractAmount, investigationJdeContractId }, relationContractList } = this.state;
        const { currencyCode } = getMatchOption(relationContractList, 'investigationJdeContractId', investigationJdeContractId);
        if (CONSTANTS[type]['edit'] || (CONSTANTS[type]['initiate'] && canEdit) || CONSTANTS[type]['copy']) {
            if (CONSTANTS[calculateType]) {
                this.handleSelectChange(cashReqRate, 'cashReqRate');
            } else {
                if (CONSTANTS[currencyCode]) {
                    this.handleSelectChange(remittanceAmount, 'remittanceAmount')
                } else {
                    this.handleSelectChange(initialContractAmount, 'initialContractAmount')
                }
            }
        }
    }

    queryRemittanceNum = () => {
        const { saveParams, type } = this.state;
        const { investigationJdeContractId } = saveParams;
        if (!investigationJdeContractId) {
            return;
        }
        Fetch.post(API_URL.contract.queryRemittanceNum, {
            investigationJdeContractId,
        }).then(res => {
            const { data = [] } = res;
            if (this.remittanceNum && CONSTANTS[type]['edit']) data.push(this.remittanceNum);
            data.sort((a, b) => a - b);
            this.setState({ remittanceNumList: data });
        }).catch(error => {
            console.error(error);
        });
    }

    queryJdeContractSiteList = () => {
        const { investigationJdeContractId } = this.state.saveParams;
        if (!investigationJdeContractId) {
            return;
        }
        Fetch.post(API_URL.contract.queryJdeContractSiteList, { investigationJdeContractId }).then(res => {
            const { data = [] } = res;
            this.setState({ JdeContractSiteList: data.length ? [{investigationSiteId:'-1', investigationSiteName:'所有中心'},...data] : data });
        }).catch(error => {
            console.error(error);
        });
    }

    queryStopBreathingCode = () => {
        Fetch.post(API_URL.contract.queryStopBreathingCode, { type:'paymentAmount'}).then(res => {
            const { data = [] } = res;
            this.setState({ paymentAmountList: data });
        }).catch(error => {
            console.error(error);
        });
    }
    
    queryStopBreathingReason = (code) => {
        if(!code) return;
        Fetch.post(API_URL.contract.queryStopBreathingReason, {type:'paymentAmount',code}).then(res => {
            const { data = [] } = res;
            this.setState({ paymentStopBreathingIdList: data });
        }).catch(error => {
            console.error(error);
        });
    }
    
    queryContractRemittanceNodes = () => {
        const { saveParams, type } = this.state;
        const { investigationJdeContractId, contractRemittanceApplicationId } = saveParams;
        if (!investigationJdeContractId) {
            return;
        }
        Fetch.post(API_URL.contract.queryContractRemittanceNodes, {
            investigationJdeContractId,filterUsed:'TRUE',contractRemittanceApplicationId: (CONSTANTS[type]['add'] || CONSTANTS[type]['autoAdd'] || CONSTANTS[type]['copy']) ? null : contractRemittanceApplicationId
        }).then(res => {
            const { data = [] } = res;
            this.setState({ nodeList: data },() => {
                if( saveParams.remittanceNodeId && !this.state.nodeList.some( el => el.contractRemittanceNodeId == saveParams.remittanceNodeId) ){
                    this.setState({ saveParams:{...saveParams, cashReqNode:undefined, remittanceNodeId:undefined } })
                }else {
                    CONSTANTS[type]['autoAdd'] && this.handleSelectChange(saveParams.cashReqNode, 'cashReqNode')
                }
            });
        }).catch(error => {
            console.error(error);
        });
    }

    queryContractRemittanceList = () => {
        const { invId } = sessionStorage;
        const { record: { remittanceCode } } = this.state;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.queryContractRemittanceList, {
            remittanceCode,
            curInvId: invId,
        }).then(res => {
            const { data: { datas } } = res;
            this.setState({ loading: false }, () => {
                this.converseRequsetRecord(datas[0]);
            });
        }).catch(error => {
            console.error(error);
        });
    }

    converseRequsetRecord = (target) => {
        const { pmUserList, baUserList, bdUserList, ...rest } = target || {};
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.recordContractRemittanceApplication, {
            ...rest,
            pm: this.resolveUserListToString(pmUserList),
            ba: this.resolveUserListToString(baUserList),
            bd: this.resolveUserListToString(bdUserList),
        }).then(() => {
            this.setState({ loading: false }, () => {
                this.hide();
                this.props.loadData();  
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    resolveUserListToString = (list, role) => {
        return  (list || []).filter(
            i => role === 'BA' ? !i.baStatus : true
        ).map(item => {
            const { userName, employeeCode } = item;
            return format('joint', userName, employeeCode);
        }).join(',');
    }

    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    handleRemove = (key) => {
        const { saveParams } = this.state;
        switch (key) {
            case 'cashReqNodeType':
                saveParams.cashReqNodeType = undefined;
                saveParams.cashReqNodeNum = undefined;
        }
        this.setState({ saveParams });
    }

    handleDateChange = (date, dateString, key) => {
        const { saveParams } = this.state;
        saveParams[key] = dateString;
        this.setState({ saveParams });
    }

    handleInputChange = (e, key) => {
        const { saveParams } = this.state;
        const value = e.target.value;
        if (key === 'cashReqNodeType') {
            saveParams[key] = value;
            saveParams.cashReqNodeNum = undefined;
        } else {
            saveParams[key] = value;
        }
        this.setState({ saveParams });
    }

    handleSelectChange = (value, key) => {
        const { saveParams, relationContractList, nodeList, JdeContractSiteList } = this.state;
        const { investigationJdeContractId } = saveParams;
        const {
            initialContractAmount: initialJdeContractAmount,
            jdeContractAmount,
            currencyCode,
            exchangeRate,
        } = getMatchOption(relationContractList, 'investigationJdeContractId', investigationJdeContractId);
        switch(key) {
           case 'investigationJdeContractId': {
                const { investigationId, investigationName } = saveParams;
                const { remittanceNum, investigationJdeContractCode, contractRemittanceApplication } = getMatchOption(relationContractList, 'investigationJdeContractId', value);
                const settings = {};
                if (!remittanceNum) {
                    settings.remittanceNum = 1;
                    settings.isAdvanceCollection = '1';
                }
                const tableData = {};
                if (contractRemittanceApplication) {
                    const { cashReqUsers, invoiceMailUsers, invoiceTypeId, hospitalNameAndAmount } = contractRemittanceApplication;
                    tableData.requestData = initialTableData(cashReqUsers);
                    tableData.invoiceData = initialTableData(invoiceMailUsers);
                    settings.invoiceTypeId = invoiceTypeId;
                    settings.hospitalNameAndAmount = hospitalNameAndAmount;
                }
                this.setState({
                    saveParams: {
                        ...saveParams,
                        investigationId,
                        investigationName,
                        investigationJdeContractCode,
                        investigationJdeContractId: value,
                        ...settings,
                    },
                    ...tableData
                }, () => {
                    this.queryRemittanceNum();
                    this.queryJdeContractSiteList();
                    this.queryContractRemittanceNodes();
                });
                return;
            }
            case 'invSiteIds': {
                let newValue = [...value];
                if( value.some( el => el == '-1' ) ){
                    newValue = [];
                    JdeContractSiteList.forEach( el => {
                        el.investigationSiteId != '-1' && newValue.push(String(el.investigationSiteId));
                    })
                }
                saveParams[key] = newValue;
                saveParams.contractSiteIds = value.length ? newValue.join(';') : '';
                break;
            }
            case 'cashReqRate': {
                saveParams[key] = value;
                if (value || value === 0) {
                    if (CONSTANTS[currencyCode]) {
                        saveParams.initialContractAmount = '';
                        // saveParams.remittanceAmount = ((jdeContractAmount || 0) * (value / 100)).toFixed(2);
                    } else {
                        const initialContractAmount = ((initialJdeContractAmount || 0) * (value / 100)).toFixed(2);
                        saveParams.initialContractAmount = initialContractAmount;
                        // saveParams.remittanceAmount = (initialContractAmount * exchangeRate).toFixed(2);
                    } 
                } else {
                    saveParams.remittanceAmount = '';
                    saveParams.initialContractAmount = '';
                }
                break;
            }
            case 'initialContractAmount': {
                saveParams[key] = value;
                if (value) {
                    saveParams.cashReqRate = ((value / initialJdeContractAmount) * 100).toFixed(2);
                    // saveParams.remittanceAmount = (value * exchangeRate).toFixed(2);
                } else {
                    saveParams.cashReqRate = '';
                    saveParams.remittanceAmount = '';
                }
                break;
            }
            // case 'remittanceAmount': {
            //     saveParams[key] = value;
            //     saveParams.initialContractAmount = '';
            //     if (value) {
            //         saveParams.cashReqRate = ((value / jdeContractAmount) * 100).toFixed(2);
            //     } else {
            //         saveParams.cashReqRate = '';
            //     }
            //     break;
            // }
            case 'remittanceNum': {
                saveParams[key] = value;
                saveParams.isAdvanceCollection = value == 1 ? '1' : '0';
                break;
            }
            case 'cashReqNode': {
                const valueOption = nodeList.find( el => el.contractRemittanceNodeId == value )
                saveParams[key] = valueOption.cashReqNode;
                saveParams['remittanceNodeId'] = value;
                saveParams.remittanceNum = valueOption.cashReqNodeNum;
                saveParams.calculateType = valueOption.calculateType;
                saveParams.cashReqRate = valueOption.cashReqRate;
                saveParams.initialContractAmount = valueOption.remittanceAmount;
                saveParams.remittanceAmount = valueOption.remittanceCnyAmount;
                saveParams.expenseTypeId = valueOption.expenseTypeId;
                break;
            }
            case 'paymentStopBreathingCode': {
                saveParams[key] = value;
                saveParams.paymentStopBreathingId = undefined;
                this.queryStopBreathingReason(value)
            }
            default: {
                saveParams[key] = value;
                break;
            }
        }
        this.setState({ saveParams });
    }

    handleChange = (option) => {
        const { saveParams } = this.state;
        const { value, text } = option;
        this.setState({
            saveParams: {
                ...saveParams,
                investigationId: value,
                investigationName: text,
                calculateType: calculateTypeOptions[0].value,
            },
            investigationOption: option,
        }, () => {
            this.loadRelationContractList(value);
        });
    }

    handleClick = () => {
        const { saveParams } = this.state;
        const { investigationId, investigationJdeContractId } = saveParams;
        if (!investigationId) {
            message.warning('请选择项目简称');
            return;
        }
        this.jdeRef.show(investigationJdeContractId);
    }

    handleDataChange = (data, key) => {
        this.setState({ [key]: data });
    }

    getUserParams = () => {
        const { requestData, invoiceData } = this.state;

        let idx = 0;
        const params = {};
        const addParams = (data, type) => {
            (data || []).forEach(i => {
                const { userName, userMobile, userMail, address, contractRemittanceUserId } = i;
                params[`contractRemittanceUserList[${idx}].contractRemittanceUserId`] = contractRemittanceUserId;
                params[`contractRemittanceUserList[${idx}].type`] = type;
                params[`contractRemittanceUserList[${idx}].userName`] = userName;
                params[`contractRemittanceUserList[${idx}].userMobile`] = userMobile;
                params[`contractRemittanceUserList[${idx}].userMail`] = userMail;
                params[`contractRemittanceUserList[${idx}].address`] = address;
                idx++;
            });
        }
        addParams(requestData, 'CASH_REQ_CONTACT');
        addParams(invoiceData, 'INVOICE_MAIL_CONTACT');

        return params;
    }

    submit = (isShow) => {
        const {
            type,
            canEdit,
            saveParams,
            relationContractList,
            fileList,
            requestData,
            invoiceData,
        } = this.state;
        const {
            investigationId,
            investigationJdeContractId,
            remittanceContractNatureId,
            hospitalNameAndAmount,
            invSiteIds,
            remittanceNum,
            cashReqNode,
            remittanceNodeId,
            cashReqNodeType,
            cashReqNodeNum,
            calculateType,
            cashReqRate,
            initialContractAmount,
            remittanceAmount,
            expenseTypeId,
            invoiceTypeId,
            invoiceTypeComment,
            isAdvanceCollection,
            isPaymentDifficult,
            paymentStopBreathingCode,
            paymentStopBreathingId,
        } = saveParams;
        const {
            currencyCode,
            jdeContractAmount,
            initialContractAmount: initialJdeContractAmount,
        } = getMatchOption(relationContractList, 'investigationJdeContractId', investigationJdeContractId);
        if (CONSTANTS[type]['editable_con']) {
            if (CONSTANTS[currencyCode]) {
                if ((jdeContractAmount < 0 && remittanceAmount > 0) || (jdeContractAmount > 0 && remittanceAmount < 0)) {
                    message.warning('合同约定请款金额的正负，需和合同总金额的正负保持一致');
                    return;
                }
            } else {
                if ((initialJdeContractAmount < 0 && initialContractAmount > 0) || (initialJdeContractAmount > 0 && initialContractAmount < 0)) {
                    message.warning('合同约定请款金额的正负，需和合同总金额的正负保持一致');
                    return;
                }
            }
        }
        if (CONSTANTS[type]['editable_pro']) {
            if (!investigationId) {
                message.warning('请选择项目简称');
                return;
            } else if (!investigationJdeContractId) {
                message.warning('请选择JDE项目号');
                return;
            }
        }
        if (CONSTANTS[type]['editable_con'] || canEdit) {
            if (!remittanceContractNatureId) {
                message.warning('请选择合同性质');
                return;
            } else if (!invSiteIds.length) {
                message.warning('请输入医院名称或数量');
                return;
            } else if (!remittanceNum) {
                message.warning('请选择请款笔数');
                return;
            } else if (!remittanceNodeId) {
                message.warning('请选择请款节点');
                return;
            } else if (cashReqNodeType && !cashReqNodeNum) {
                if (cashReqNodeType === 'NNF') {
                    message.warning('请输入本请款节点对应的例数');
                    return;
                } else {
                    message.warning('请输入本请款节点对应的“合同开始后”多少天');
                    return;
                }
            } else if (!isAdvanceCollection) {
                message.warning('请选择是否预收款');
                return;
            } else if (!calculateType) {
                message.warning('请选择合同约定请款金额计算方式');
                return;
            } else if (CONSTANTS[calculateType]) {
                if (!cashReqRate && cashReqRate !== 0) {
                    message.warning('请选择合同约定请款比例');
                    return;
                }
            } else {
                if (!CONSTANTS[currencyCode] && !initialContractAmount && initialContractAmount !== 0) {
                    message.warning('请输入合同约定请款金额/原币');
                    return;
                }
                if (!remittanceAmount && remittanceAmount !== 0) {
                    message.warning('请输入合同约定请款金额/人民币');
                    return;
                }
            }
            if (!expenseTypeId) {
                message.warning('请选择费用类型');
                return;
            } else if (!invoiceTypeId) {
                message.warning('请选择发票类型');
                return;
            }
        }
        if (CONSTANTS[type]['initiate'] && !canEdit) {
            if ((!fileList || (fileList.length === 0))) {
                message.warning('请选择请款附件');
                return;
            }
            if (!invoiceTypeComment) {
                message.warning('请输入发票备注要求');
                return;
            }
            if ((requestData || []).every(i => !i.userName && !i.userMobile && !i.userMail)) {
                message.warning('请添加请款联系人');
                return;
            }
            if ((invoiceData || []).every(i => !i.userName && !i.userMobile && !i.userMail && !i.address)) {
                message.warning('请添加发票邮寄联系人');
                return;
            }
        }

        // if(CONSTANTS[type]['update'] && isPaymentDifficult == '1' && !paymentStopBreathingCode){
        //     message.warning('请选择请款卡脖子节点');
        //     return;
        // }

        // if(CONSTANTS[type]['update'] && paymentStopBreathingCode && !paymentStopBreathingId) {
        //     message.warning('请选择请款卡脖子节点原因');
        //     return;
        // }

        if (CONSTANTS[type]['add'] || CONSTANTS[type]['autoAdd'] || CONSTANTS[type]['copy']) {
            this.setState({ loading: true }, () => {
                const callback = (success) => {
                    if (!success) {
                        this.setState({ loading: false });
                    } else {
                        this.setState({ loading: false }, () => {
                            this.save(isShow);
                        });
                    }
                };
                callback.handleError = true;
                this.props.queryInvestigationStageByInvId(investigationId, callback);
            });
        } else {
            this.save(isShow);
        }
    }

    save = (isShow) => {
        const { type, canEdit, saveParams, fileList, relationContractList } = this.state;
        const { remittanceNum, investigationJdeContractId } = saveParams;
        const { currencyCode, remittanceNum: contractRemittanceNum } = getMatchOption(relationContractList, 'investigationJdeContractId', investigationJdeContractId);
        if (CONSTANTS[currencyCode] && (CONSTANTS[type]['editable_con'] || canEdit)) {
            saveParams.initialContractAmount = '';
        }

        const userParams = this.getUserParams();

        const params = {};
        if ((fileList || []).length) {
            fileList.forEach((item, index) => {
                params[`ids[${index}]`] = item.response.fileMetaId;
            });
        } 

        this.setState({ loading: true });
        Fetch.post(CONSTANTS[isShow ? 'edit' : type].SAVE_URL, {
            ...saveParams,
            ...userParams,
            ...params,
            paymentDate: saveParams.paymentDate ? moment(saveParams.paymentDate).format('YYYY-MM-DD') : undefined,
            remittanceNum: `第${remittanceNum}笔`,
            type: CONSTANTS[isShow ? 'edit' : type].SAVE_TYPE,
            isFirst: (remittanceNum == 1 && !contractRemittanceNum) ? 1 : 0,
        }).then(res => {
            message.success(CONSTANTS[type]['copy'] ? '复制新建成功' : res.success);
            this.setState({
                loading: false,
            }, () => {
                if (!isShow) {
                    if (CONSTANTS[type]['initiate']) {
                        this.queryContractRemittanceList();
                    } else if (CONSTANTS[type]['add'] || CONSTANTS[type]['autoAdd']) {
                        this.setState({ visible: false }, () => {
                            this.props.continueAdd(this.state);
                        });
                    } else {
                        this.hide();
                        this.props.loadData();
                    }
                } else {
                    this.setState({ canEdit: false }, () => {
                        this.loadData();
                    });
                }
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false }, () => {
                if (CONSTANTS[type]['initiate']) this.toggleCanEdit(false, 'cancle');
            });
        });
    }

    filterRole = (data, role) => {
        const result = [];
        (data || []).forEach(item => {
            const { roleCode, userName, employeeCode, userCompellation } = item;
            if (role ? (roleCode === role) : true) {
                result.push(format('joint', role ? userCompellation : userName, employeeCode));
            }
        });
        return result.join('; ');
    }

    handleUploadChange = (file, fileList) => {
        this.setState({ fileList });
    }

    getContent = () => {
        const { listCollection } = this.props;
        const {
            contractNature = [],
            expenseType = [],
            invoiceType = [],
            paymentProgress = [],
        } = listCollection;
        const {
            type,
            record,
            canEdit,
            saveParams,
            fileList,
            nodeList,
            uesrData,
            remittanceNumList,
            investigationOption,
            relationContractList,
            paymentAmountList,
            JdeContractSiteList,
            paymentStopBreathingIdList,
        } = this.state;
        const {
            investigationName,
            investigationJdeContractId,
            investigationJdeContractCode,
            remittanceContractNatureId,
            hospitalNameAndAmount,
            invSiteIds,
            remittanceNum,
            remittanceNodeId,
            cashReqNode,
            cashReqNodeType,
            cashReqNodeNum,
            calculateType,
            cashReqRate,
            initialContractAmount,
            remittanceAmount,
            expenseTypeId,
            invoiceTypeId,
            invoiceTypeComment,
            paymentProgressId,
            paymentProgressComment,
            isAdvanceCollection,
            isVerification,
            isPaymentDifficult,
            paymentStopBreathingCode,
            paymentStopBreathingId,
            paymentDate,
        } = saveParams;
        const {
            contractRemittanceApplicationId,
            status: remittanceStatus,
            investigationJdeContractId: currentJdeContractId,
            customerCompany,
            isFirst,
            isAdvanceCollectionShow,
            isPaymentDifficultShow,
            isVerificationShow,
            paymentStopBreathingReason,
        } = record;
        const { curRole } = sessionStorage;
        const { users, investigationCode, lineOfBusinessString } = investigationOption || {};
        const remittanceNumOptions = remittanceNumList.map(i => <Option key={String(i)}>{i}</Option>);
        const JdeContractSiteOptions = JdeContractSiteList.map(i => <Option key={String(i.investigationSiteId)}>{i.investigationSiteCode ? `${i.investigationSiteName}(${i.investigationSiteCode})` : `${i.investigationSiteName}`}</Option>);
        const contractNatureOptions = contractNature.map(i => <Option key={String(i.contractRemittanceDictId)}>{i.dictName}</Option>);
        const expenseTypeOptions = expenseType.map(i => <Option key={String(i.contractRemittanceDictId)}>{i.dictName}</Option>);
        const invoiceTypeOptions = invoiceType.map(i => <Option key={String(i.contractRemittanceDictId)}>{i.dictName}</Option>);
        const paymentProgressOptions = paymentProgress.map(i => <Option key={String(i.contractRemittanceDictId)}>{i.dictName}</Option>);
        const nodeOptions = nodeList.map(i => <Option key={String(i.contractRemittanceNodeId)}>{i.cashReqNode}</Option>);
        const remittanceContractNature = getMatchOption(contractNature, 'contractRemittanceDictId', remittanceContractNatureId)['dictName'];
        const expenseTypeName = getMatchOption(expenseType, 'contractRemittanceDictId', expenseTypeId)['dictName'];
        const invoiceTypeName = getMatchOption(invoiceType, 'contractRemittanceDictId', invoiceTypeId)['dictName'];
        const paymentProgressName = getMatchOption(paymentProgress, 'contractRemittanceDictId', paymentProgressId)['dictName'];
        const defaultOptions = defaultList.map(i => <Option key={i.value}>{i.label}</Option>);
        const paymentAmountOptions = paymentAmountList.map(i => <Option key={i.code}>{i.code}</Option>);
        const paymentStopBreathingIdOptions = paymentStopBreathingIdList.map(i => 
            <Option key={i.stopBreathingId}>
                <Tooltip placement="right" title={i.reason}>
                    <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{i.reason}</span>
                </Tooltip>
            </Option>);
        const {
            belongingToUnit,
            belongingToUnitCode,
            customerCompanyName,
            customerCompanyCode,
            contractTypeValue,
            secondLineNames,
            currencyName,
            currencyCode,
            exchangeRate,
            remittanceNum: contractRemittanceNum,
            initialContractAmount: initialJdeContractAmount,
            jdeContractAmount,
            startTime,
            endTime,
            files = [],
            baUserList = [],
        } = getMatchOption(relationContractList, 'investigationJdeContractId', investigationJdeContractId);

        let currentCompanyName = customerCompanyName;
        let currentCompanyCode = customerCompanyCode;
        // 当选择的jde和记录的jde相等时，优先取记录的客户
        if (currentCompanyName && customerCompany && currentJdeContractId && currentJdeContractId == investigationJdeContractId && !CONSTANTS[type]['autoAdd']) {
           const idx = customerCompany.lastIndexOf('(');
           currentCompanyName = customerCompany.slice(0, idx);
           currentCompanyCode = customerCompany.slice(idx + 1, -1);
        }

        const { invState } = sessionStorage;
        const isTotal = invState == 1;
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={CONSTANTS[type]['editable_pro']} colon={true}>项目简称</Text></div>
                    <div className="item-right">
                        <SearchRetrieve
                            disabled={!CONSTANTS[type]['editable_pro'] || isTotal}
                            keyword='investigationName'
                            style={{ width: 200 }}
                            placeholder="输入名称检索"
                            value={investigationName}
                            params={{ limit: 20, needRoleBA: (CONSTANTS[type]['add'] || CONSTANTS[type]['autoAdd'] || CONSTANTS[type]['copy']) ? 1 : 0 }}
                            url={API_URL.contract.selectInvestigationForAddRemittance}
                            config={{ id: 'investigationId', name: 'investigationName' }}
                            onChange={this.handleChange}
                        />
                    </div>
                </li>
                {/* 取项目中的信息-开始 */}
                <li className="modal-item">
                    <div className="item-left">项目编号:</div>
                    <div className="item-right">{investigationCode}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">BD:</div>
                    <div className="item-right">{this.filterRole(users, 'BD')}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">PM:</div>
                    <div className="item-right">{this.filterRole(users, 'PM')}</div>
                </li>
                {/* 取项目中的信息-结束 */}
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={CONSTANTS[type]['editable_pro']} colon={true}>JDE项目号</Text></div>
                    <div className="item-right">
                        {
                            CONSTANTS[type]['editable_pro'] ?
                                <Input
                                    placeholder="请选择"
                                    style={{ width: 182 }}
                                    value={investigationJdeContractCode}
                                    onClick={this.handleClick}
                                />
                            :
                                investigationJdeContractCode
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={CONSTANTS[type]['editable_con'] || canEdit} colon={true}>合同性质</Text></div>
                    <div className="item-right">
                        {
                            (CONSTANTS[type]['editable_con'] || canEdit) ?
                                <Select
                                    placeholder="请选择"
                                    style={{width: 182}}
                                    onChange={value => this.handleSelectChange(value, 'remittanceContractNatureId')}
                                    value={remittanceContractNatureId ? String(remittanceContractNatureId) : undefined}
                                    allowClear={true}
                                >
                                    {contractNatureOptions}
                                </Select>
                            :
                                remittanceContractNature
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">收入归属单位名称:</div>
                    <div className="item-right">
                        {belongingToUnit}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">收入归属单位代号:</div>
                    <div className="item-right">
                        {belongingToUnitCode}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">客户付款单位名称:</div>
                    <div className="item-right">{currentCompanyName}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">客户付款单位代号:</div>
                    <div className="item-right">{currentCompanyCode}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">申请人:</div>
                    <div className="item-right">{
                        (CONSTANTS[type]['add'] || CONSTANTS[type]['autoAdd'] || CONSTANTS[type]['copy'])?
                        (uesrData.userCompellation ? `${uesrData.userCompellation}[${uesrData.employeeCode}]` : '')
                        :
                        `${saveParams.baUserName}[${saveParams.baEmployeeCode}]`
                    }</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">计收入确认方式:</div>
                    <div className="item-right">{contractTypeValue}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">业务线:</div>
                    <div className="item-right">{lineOfBusinessString}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">执行业务线二级分类:</div>
                    <div className="item-right">{secondLineNames}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={CONSTANTS[type]['editable_con'] || canEdit} colon={true}>医院名称或数量</Text></div>
                    <div className="item-right">
                        {
                            (CONSTANTS[type]['editable_con'] || canEdit) ?
                                <Select
                                    mode="multiple"
                                    allowClear={true}
                                    style={{ width: 200 }}
                                    placeholder="请选择"
                                    value={invSiteIds}
                                    onChange={value => this.handleSelectChange(value, 'invSiteIds')}
                                >
                                    {JdeContractSiteOptions}
                                </Select>
                            :
                                (hospitalNameAndAmount || '').split(';').map( el => { return <p>{el}</p>})
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">币种:</div>
                    <div className="item-right">
                        {format('joint', currencyName, currencyCode, 'roundBrackets')}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">汇率:</div>
                    <div className="item-right">
                        {exchangeRate}
                    </div>
                </li>
                {
                    currencyCode && !CONSTANTS[currencyCode] &&
                    <li className="modal-item">
                        <div className="item-left">合同总金额/原币:</div>
                        <div className="item-right">
                            {format('money', initialJdeContractAmount)}&nbsp;{currencyName}
                        </div>
                    </li>
                }
                <li className="modal-item">
                    <div className="item-left">合同总金额/人民币:</div>
                    <div className="item-right">
                        {format('money', jdeContractAmount)}&nbsp;元
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">合同开始时间:</div>
                    <div className="item-right">
                        {startTime}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">合同结束时间:</div>
                    <div className="item-right">
                        {endTime}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">合同附件:</div>
                    <div className="item-right">
                        {files.map(i => <a onClick={e => this.downLoadFile(e, i.id)}>{i.name}<br /></a>)}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text colon={true}>请款附件</Text></div>
                    <div className="item-right">
                        {
                            (CONSTANTS[type]['editable_con'] || canEdit) ?
                                <UploadFile
                                    data={{
                                        uploadType,
                                        relateId: contractRemittanceApplicationId || '',
                                        path: this.timestamp,
                                    }}
                                    fileList={fileList}
                                    uploadUrl={API_URL.common.uploadEnclosureFile}
                                    removeUrl={API_URL.common.deleteEnclosureFile}
                                    onChange={this.handleUploadChange}
                                />
                            :
                                fileList.map(i => <a onClick={e => this.downLoadFile(e, i.id)}>{i.name}<br /></a>)
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={(CONSTANTS[type]['editable_con'] || canEdit)} colon={true}>请款笔数</Text></div>
                    <div className="item-right">
                        {
                            !!remittanceNum && `第${remittanceNum}笔`
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={(CONSTANTS[type]['editable_con'] || canEdit)} colon={true} highLight={(CONSTANTS[type]['copy'] || this.highlight) && '#F00'}>请款节点</Text></div>
                    <div className="item-right">
                        {
                            (CONSTANTS[type]['editable_con'] || canEdit) ?
                                <Select
                                placeholder="请选择"
                                style={{ width: 182 }}
                                value={remittanceNodeId ? String(remittanceNodeId) : undefined}
                                onChange={value => this.handleSelectChange(value, 'cashReqNode')}
                                >
                                    {nodeOptions}
                                </Select>
                            :
                                cashReqNode ? `${cashReqNode}${cashReqNodeType ? cashReqNodeType === 'NNF' ? `(${cashReqNodeNum}例)` : `(合同开始后${cashReqNodeNum}天)` : ''}` : ''
                        }
                    </div>
                </li>
                {
                    cashReqNode && (CONSTANTS[type]['editable_con'] || canEdit) &&
                    <li className="modal-item">
                        <div className="item-left">&nbsp;</div>
                        <div className="item-right">
                            <RadioGroup
                                value={cashReqNodeType}
                                onChange={e => this.handleInputChange(e, 'cashReqNodeType')}
                            >
                                { cashReqNodeTypeOptions.map(i => <Radio key={i.value} value={i.value}>{i.label}</Radio>) }
                                <span className="clearValue" onClick={() => this.handleRemove('cashReqNodeType')}>×</span>
                            </RadioGroup>
                        </div>
                    </li>
                }
                {
                    cashReqNodeType === 'NNF' && (CONSTANTS[type]['editable_con'] || canEdit) &&
                    <li className="modal-item">
                        <div className="item-left">&nbsp;</div>
                        <div className="item-right">
                            <InputNumber
                                min={0}
                                precision={0}
                                placeholder="请输入"
                                style={{ width: 180, marginRight: 10 }}
                                value={cashReqNodeNum}
                                onChange={value => this.handleSelectChange(value, 'cashReqNodeNum')}
                            />
                            例
                        </div>
                    </li>
                }
                {
                    cashReqNodeType === 'CYCLE' && (CONSTANTS[type]['editable_con'] || canEdit) &&
                    <li className="modal-item">
                        <div className="item-left">&nbsp;</div>
                        <div className="item-right">
                            合同开始后
                            <InputNumber
                                min={0}
                                precision={0}
                                placeholder="请输入"
                                style={{ width: 100, margin: '0 10px' }}
                                value={cashReqNodeNum}
                                onChange={value => this.handleSelectChange(value, 'cashReqNodeNum')}
                            />
                            天
                        </div>
                    </li>
                }
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={(CONSTANTS[type]['editable_con'] || canEdit)} colon={true}>是否预收款</Text></div>
                    <div className="item-right">
                        {
                            (CONSTANTS[type]['editable_con'] || canEdit) ?
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 182 }}
                                    value={isAdvanceCollection ? String(isAdvanceCollection) : undefined}
                                    onChange={value => this.handleSelectChange(value, 'isAdvanceCollection')}
                                >
                                    { defaultOptions }
                                </Select>
                            :
                            isAdvanceCollectionShow
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={(CONSTANTS[type]['editable_con'] || canEdit)} colon={true}>合同约定请款金额计算方式</Text></div>
                    <div className="item-right">{calculateType ? CONSTANTS[calculateType] ? '由比例计算金额' : '由金额计算比例' : ''}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left">
                        <Text asterisk={(CONSTANTS[type]['editable_con'] || canEdit) && CONSTANTS[calculateType]} colon={true} highLight={(CONSTANTS[type]['copy'] || this.highlight) && CONSTANTS[calculateType] && '#F00'}>合同约定请款比例</Text>
                    </div>
                    <div className="item-right">{cashReqRate} %</div>
                </li>
                {
                    currencyCode && !CONSTANTS[currencyCode] &&
                    <li className="modal-item">
                        <div className="item-left">
                            <Text asterisk={(CONSTANTS[type]['editable_con'] || canEdit)} colon={true} highLight={(CONSTANTS[type]['copy'] || this.highlight) && !CONSTANTS[calculateType] && '#F00'}>合同约定请款金额/原币</Text>
                        </div>
                        <div className="item-right">{format('money', initialContractAmount)} {currencyName}</div>
                    </li>
                }
                <li className="modal-item">
                    <div className="item-left">
                        <Text asterisk={(CONSTANTS[type]['editable_con'] || canEdit) && !CONSTANTS[calculateType] && CONSTANTS[currencyCode]} colon={true} highLight={(CONSTANTS[type]['copy'] || this.highlight) && !CONSTANTS[calculateType] && '#F00'}>合同约定请款金额/人民币</Text>
                    </div>
                    <div className="item-right">{format('money', remittanceAmount)} 元</div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={(CONSTANTS[type]['editable_con'] || canEdit) && remittanceStatus !== 'AGREE_REMITTANCE_ADJUSTMENT_APPLY'} colon={true}>费用类型</Text></div>
                    <div className="item-right">{expenseTypeName}</div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text asterisk={(CONSTANTS[type]['editable_con'] || canEdit)} colon={true}>发票类型</Text></div>
                    <div className="item-right">
                        {
                            (CONSTANTS[type]['editable_con'] || canEdit) ?
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 182 }}
                                    value={invoiceTypeId ? String(invoiceTypeId) : undefined}
                                    onChange={value => this.handleSelectChange(value, 'invoiceTypeId')}
                                >
                                    {invoiceTypeOptions}
                                </Select>
                            :
                                invoiceTypeName
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left"><Text colon={true}>发票备注要求</Text></div>
                    <div className="item-right">
                        {
                            (CONSTANTS[type]['editable_con'] || canEdit) ?
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 182 }}
                                    value={invoiceTypeComment}
                                    onChange={e => this.handleInputChange(e, 'invoiceTypeComment')}
                                />
                            :
                                invoiceTypeComment
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">请款特殊说明:</div>
                    <div className="item-right">
                        {
                            (CONSTANTS[type]['editable_con'] || canEdit) ?
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 182 }}
                                    value={saveParams.specialComments}
                                    onChange={e => this.handleInputChange(e, 'specialComments')}
                                />
                            :
                                saveParams.specialComments
                        }
                    </div>
                </li>
                {
                    (CONSTANTS[type]['editable_req'] || CONSTANTS[type]['initiate']) &&
                    <li className="modal-item">
                        <div className="item-left"><Text asterisk={((!CONSTANTS[type]['update'] && !CONSTANTS[type]['initiate']) || canEdit)} colon={true}>是否正负核销</Text></div>
                        <div className="item-right">
                            {
                                ((!CONSTANTS[type]['update'] && !CONSTANTS[type]['initiate']) || canEdit) ?
                                    <Select
                                        placeholder="请选择"
                                        style={{ width: 182 }}
                                        value={isVerification}
                                        allowClear={true}
                                        onChange={value => this.handleSelectChange(value, 'isVerification')}
                                    >
                                        {defaultOptions}
                                    </Select> 
                                :
                                    isVerificationShow
                            }
                        </div>
                    </li>
                }
                {
                    CONSTANTS[type]['update'] && 
                    <li className="modal-item">
                        <div className="item-left">是否请款疑难:</div>
                        <div className="item-right">
                            <Select
                                placeholder="请选择"
                                style={{ width: 182 }}
                                allowClear={true}
                                value={isPaymentDifficult}
                                onChange={value => this.handleSelectChange(value, 'isPaymentDifficult')}
                            >
                                {defaultOptions}
                            </Select>
                        </div>
                    </li>
                }
                {
                    CONSTANTS[type]['update'] &&
                    <li className="modal-item">
                        <div className="item-left"><Text >请款卡脖子节点:</Text></div>
                        <div className="item-right">
                            <Select
                                placeholder="请选择"
                                style={{ width: 182 }}
                                allowClear={true}
                                value={paymentStopBreathingCode}
                                onChange={value => this.handleSelectChange(value, 'paymentStopBreathingCode')}
                            >
                                {paymentAmountOptions}
                            </Select>
                        </div>
                    </li>
                } 
                {
                    CONSTANTS[type]['update'] &&
                    <li className="modal-item">
                        <div className="item-left"><Text >请款卡脖子节点原因:</Text></div>
                        <div className="item-right">
                            <Select
                                dropdownClassName='CancelScrollDropdownMenu'
                                placeholder="请选择"
                                style={{ width: 182 }}
                                allowClear={true}
                                value={ paymentStopBreathingId ? String(paymentStopBreathingId) : undefined}
                                onChange={value => this.handleSelectChange(value, 'paymentStopBreathingId')}
                            >
                                {paymentStopBreathingIdOptions}
                            </Select>
                        </div>
                    </li>
                }
                {/* {
                    CONSTANTS[type]['update'] && 
                    <li className="modal-item">
                        <div className="item-left">更新请款进度日期:</div>
                        <div className="item-right">
                            <DatePicker 
                                style={{ width: 182 }}
                                value={ paymentDate ? moment(paymentDate) : null} 
                                onChange={ (date, deteStr) => this.handleSelectChange(deteStr,'paymentDate') }
                            />
                        </div>
                    </li>
                } */}
                
                <li className="modal-item">
                    <div className="item-left">请款进度:</div>
                    <div className="item-right">
                        {
                            (CONSTANTS[type]['editable_req'] || canEdit) ?
                                <Select
                                    placeholder="请选择"
                                    style={{ width: 182 }}
                                    value={paymentProgressId ? String(paymentProgressId) : undefined}
                                    onChange={value => this.handleSelectChange(value, 'paymentProgressId')}
                                >
                                    {paymentProgressOptions}
                                </Select>
                            :
                                paymentProgressName
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">请款进度具体描述:</div>
                    <div className="item-right">
                        {
                            (CONSTANTS[type]['editable_req'] || canEdit) ?
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 182 }}
                                    value={paymentProgressComment}
                                    onChange={e => this.handleInputChange(e, 'paymentProgressComment')}
                                />
                            :
                                paymentProgressComment
                        }
                    </div>
                </li>
            </ul>
        )
    }

    toggleCanEdit = (canEdit, type) => {
        const { record, saveParams } = this.state;
        const { cashReqUsers, invoiceMailUsers, pmUserList, bdUserList, ...rest } = record;
        let params = {};
        if (type === 'cancle') {
            params.saveParams = Object.assign(saveParams, rest);
            params.requestData = cashReqUsers ? cashReqUsers.map(i => ({...i})) : [];
            params.invoiceData = invoiceMailUsers ? invoiceMailUsers.map(i => ({...i})) : [];
        } else if (type === 'confirm') {
            this.submit(true);
            return;
        }
        this.setState({
            canEdit,
            ...params,
        }, () => {
            canEdit && this.recomputeContractAmount();
        });
    }

    render() {
        const { type, canEdit, visible, loading, requestData, invoiceData, relationContractList, saveParams, record } = this.state;
        let id;
        if (type === 'add') {
            const { investigationJdeContractId } = saveParams;
            const { customerCompanyId } = getMatchOption(relationContractList, 'investigationJdeContractId', investigationJdeContractId);
            id = customerCompanyId;
        } else {
            const { customerCompanyId } = saveParams;
            id = customerCompanyId;
        }
        let footer = [
            <Button type="ghost" onClick={this.hide}>取消</Button>,
            <Button type="primary" onClick={() => this.submit(false)} loading={loading}>确定</Button>,
        ];
        if (CONSTANTS[type]['initiate']) {
            if (!canEdit) {
                footer = [
                    <Button type="primary" onClick={() => this.toggleCanEdit(true, 'modify')}>编辑</Button>,
                    <Button type="primary" onClick={() => this.submit(false)} loading={loading}>发起请款</Button>,
                ];
            } else {
                footer = [
                    <Button type="ghost" onClick={() => this.toggleCanEdit(false, 'cancle')}>取消</Button>,
                    <Button type="primary" onClick={() => this.toggleCanEdit(false, 'confirm')} loading={loading}>确定</Button>,
                ];
            }
        }
        return (
            <Modal
                title={CONSTANTS[type].TITLE}
                visible={visible}
                onCancel={this.hide}
                onOk={() => this.submit(false)}
                bodyStyle={{ maxHeight: 500 }}
                maskClosable={false}
                width="700px"
                footer={footer}
            >
                 <Spin spinning={loading}>
                    <div className="modal-content heredity" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                        <EditableTable
                            customerCompanyId={id}
                            canEdit={CONSTANTS[type]['editable_req'] || canEdit}
                            btnText="添加请款联系人"
                            columns={requestColumns}
                            dataSource={requestData}
                            onChange={data => this.handleDataChange(data, 'requestData')}
                        />
                        <EditableTable
                            customerCompanyId={id}
                            canEdit={CONSTANTS[type]['editable_req'] || canEdit}
                            btnText="添加发票邮寄联系人"
                            columns={invoiceColumns}
                            dataSource={invoiceData}
                            onChange={data => this.handleDataChange(data, 'invoiceData')}
                        />
                    </div>
                    <SelectinvestigationJdeCode
                        data={relationContractList}
                        ref={el => this.jdeRef = el}
                        onChange={value => this.handleSelectChange(value, 'investigationJdeContractId')}
                    />
                </Spin>
            </Modal>
        );
    }
}

export default Update;



// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/Update.js